module.exports = __webpack_public_path__ + "static/img/flowpackage.5cd6461c.jpg";